import * as React from 'react';
import { DetailsList, SelectionMode, IColumn, ISelection } from '@fluentui/react/lib/DetailsList';
import { SearchObjectService } from '../../services';
import { IEntity } from '../../types';
import { SearchBox } from '@fluentui/react/lib/SearchBox';
import { ICommandBarItemProps, ThemeProvider } from '@fluentui/react';
import { CrCommandBar } from '../cr/CrCommandBar';
import '../../styles/CustomFabric2.scss';
import styles from '../../styles/cr.module.scss';


export interface IFilteredMainListProps {
    className?: string;
    columns: IColumn[];
    items: any[];
    filterText?: string;
    onFilterChange: (value: string) => void;
    onItemTitleClick: (ID: any, title: string, filteredItems: any[]) => void;
    selection?: ISelection;
    onAdd: (iapTypeId: number) => void;
    onAddGroupActions: () => void;
    onEdit: () => void;
    onDelete: () => void;
    onAssign: () => void;
    editDisabled: boolean;
    assignDisabled: boolean;
    deleteDisabled: boolean;
}

export interface IFilteredMainListState {
    Columns: IColumn[];
    FilteredItems: any[];
}

export class FilteredMainList extends React.Component<IFilteredMainListProps, IFilteredMainListState> {
    constructor(props: IFilteredMainListProps) {
        super(props);
        props.columns.forEach((c) => { c.onColumnClick = this._onColumnClick; });
        this.state = {
            Columns: props.columns,
            FilteredItems: props.items,
        };
    }

    public render(): JSX.Element {
        const { props, state } = this;

        const commandBarItems: ICommandBarItemProps[] = [];
        const farCommandBarItems: ICommandBarItemProps[] = [];

        const addAction: ICommandBarItemProps = {
            key: 'new',
            text: 'Add Action',
            iconProps: { iconName: 'Add' },
            onClick: (ev) => props.onAdd(1),
        };

        const addGroupActions: ICommandBarItemProps = {
            key: 'new',
            text: 'Add Group Actions',
            iconProps: { iconName: 'Add' },
            onClick: props.onAddGroupActions,
        };

        const addComplianceAction: ICommandBarItemProps = {
            key: 'new',
            text: 'Add Compliance Action',
            iconProps: { iconName: 'Add' },
            onClick: (ev) => props.onAdd(6),
        };

        const editItem: ICommandBarItemProps = {
            key: 'edit',
            text: 'Edit',
            iconProps: { iconName: 'Edit' },
            onClick: props.onEdit,
        };

        const deleteItem: ICommandBarItemProps = {
            key: 'delete',
            text: 'Delete',
            iconProps: { iconName: 'Delete' },
            onClick: props.onDelete,
        };

        const assignItem: ICommandBarItemProps = {
            key: 'assign',
            text: 'Assign',
            iconProps: { iconName: 'Assign' },
            onClick: props.onAssign,
        };


        if (props.editDisabled && props.deleteDisabled)
            commandBarItems.push(addAction);

        if (props.editDisabled && props.deleteDisabled)
            commandBarItems.push(addGroupActions);

        if (props.editDisabled && props.deleteDisabled)
            commandBarItems.push(addComplianceAction);

        if (props.editDisabled === false)
            commandBarItems.push(editItem);

        if (props.deleteDisabled === false)
            commandBarItems.push(deleteItem);

        if (props.assignDisabled === false)
            commandBarItems.push(assignItem);

        if (props.onFilterChange) {
            farCommandBarItems.push(
                {
                    key: 'filter',
                    text: 'List filter',
                    inActive: true,
                    onRender: function renderFilter() {
                        return (
                            <div className={styles.crCommandBarContainer}>
                                <SearchBox placeholder="Filter items" value={props.filterText?? ''} onChange={(_, v) => props.onFilterChange(v)} className={styles.listFilterBox} />
                            </div>
                        );
                    }
                }
            );
        }

        return (
            <ThemeProvider>
                <div>
                    <CrCommandBar className={props.className} items={commandBarItems} farItems={farCommandBarItems} />
                </div>
                <DetailsList
                    setKey={"state.FilteredItems"}
                    selectionMode={SelectionMode.single}
                    selection={props.selection}
                    columns={state.Columns}
                    items={state.FilteredItems}
                    onRenderItemColumn={this.renderItemColumn}
                />
            </ThemeProvider>
        );
    }

    public componentDidMount(): void {
        this.setState({ FilteredItems: SearchObjectService.filterEntities(this.props.items, this.props.filterText) });
    }

    public componentDidUpdate(prevProps: IFilteredMainListProps): void {
        if (prevProps.columns !== this.props.columns) {
            this.props.columns.forEach((c) => { c.onColumnClick = this._onColumnClick; });
            this.setState({ Columns: this.props.columns, FilteredItems: SearchObjectService.filterEntities(this.props.items, this.props.filterText) });
        }
        else if (prevProps.items !== this.props.items || prevProps.filterText !== this.props.filterText) {

            this.setState({ FilteredItems: SearchObjectService.filterEntities(this.props.items, this.props.filterText) });
        }
    }

    private renderItemColumn = (item: IEntity, index: number, column: IColumn) => {
        let fieldContent = item[column.fieldName as keyof IEntity] as string;

        if (column.key === "Update") {

            let txtColor: string = "white";
            let bgColor: string = "";

            if (fieldContent === "Required") {
                bgColor = "rgb(34,177,76)";

                return (
                    <span style={{ backgroundColor: bgColor, color: txtColor, width: "75px", display: "block", paddingLeft: "10px", paddingTop: "5px", paddingBottom: "5px" }}>
                        {fieldContent}
                    </span>
                );

            }
            else {
                return <span>{fieldContent}</span>;
            }
        }

        else if (column.key === "Title") {
            let id: number = item["ID"];
            const filteredItem = this.state.FilteredItems;

            return (
                <span><a className="titleLnk" onClick={(ev) => this.props.onItemTitleClick(id, fieldContent, filteredItem)} > {fieldContent}</a> </span>
            );
        }
        else {
            return <span>{fieldContent}</span>;
        }
    }

    private _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { Columns, FilteredItems } = this.state;
        let newItems: any[] = FilteredItems.slice();
        const newColumns: IColumn[] = Columns.slice();
        const currColumn: IColumn = newColumns.filter((currCol: IColumn, idx: number) => {
            return column.key === currCol.key;
        })[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        newItems = this._sortItems(newItems, currColumn.fieldName || '', currColumn.isSortedDescending);
        this.setState({
            Columns: newColumns,
            FilteredItems: newItems
        });
    }

    private _sortItems = (items: any[], sortBy: string, descending = false): any[] => {
        return items.sort((a, b) => {
            if (!a.hasOwnProperty(sortBy) || !b.hasOwnProperty(sortBy)) {
                // property doesn't exist on either object
                return 0;
            }

            const varA = (typeof a[sortBy] === 'string') ? a[sortBy].toLowerCase() : a[sortBy];
            const varB = (typeof b[sortBy] === 'string') ? b[sortBy].toLowerCase() : b[sortBy];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return ((descending) ? (comparison * -1) : comparison);
        });
    }
}
